import React from 'react';
import { Box, Typography } from '@mui/material';

interface OrderCartEmptyProps {
}

const OrderCartEmpty: React.FC<OrderCartEmptyProps> = ({ }) => {
    return (
        <Box height={"100%"} display={"flex"} alignItems={"center"} justifyContent={"center"}>
            <Typography>Košarica je trenutno prazna.</Typography>
        </Box>
    )
}

export default OrderCartEmpty;